import { DeliveryType } from '@libs/core';

import { useAutoshipDecisions } from './useAutoshipDecisions';
import { useCart } from './useCart';

/**
 * Hook to check if BOPIS + Autoship scenario should show shipping address section and banner
 */
export function useIsBopisWithAutoship() {
    const { cart } = useCart();
    const { isAutoshipCrawl } = useAutoshipDecisions();

    const hasBopisWithAutoship = cart?.fulfillmentGroups?.some(
        group =>
            group.fulfillmentMethod.toLowerCase() === DeliveryType.BOPIS &&
            group.items?.some(item => item.autoshipFrequency && item.autoshipFrequencyUnitOfMeasure)
    );

    return isAutoshipCrawl && hasBopisWithAutoship;
}
